import { createFileRoute } from '@tanstack/react-router';
import { Button } from '@osd/ui/button';
import { ButtonGroup } from '@osd/ui/button-group';
import { Stack } from '@osd/ui/stack';
import { CodeBlock } from '@osd/ui/code-block';
import { Section } from '@osd/ui/section';

/**
 * /ui/button-group — live docs for the `ButtonGroup` primitive.
 *
 * `ButtonGroup` fuses a row (or column) of `<Button>`s into a
 * single bordered toolbar. Tags the first / middle / last children
 * with position classes so SCSS can collapse abutting borders —
 * the group reads as one surface, not a stack of buttons.
 */
export const Route = createFileRoute('/ui/_layout/button-group')({
  component: ButtonGroupPage,
});

function ButtonGroupPage() {
  return (
    <Stack gap={6}>
      <Section
        title="ButtonGroup"
        hint="Fused bordered toolbar (horizontal default; pass vertical for column)"
      >
        <Stack gap={3}>
          <ButtonGroup ariaLabel="Edit actions">
            <Button>Copy</Button>
            <Button>Cut</Button>
            <Button>Paste</Button>
          </ButtonGroup>

          <ButtonGroup ariaLabel="Pagination" vertical>
            <Button>Top</Button>
            <Button>Middle</Button>
            <Button>Bottom</Button>
          </ButtonGroup>
        </Stack>
      </Section>

      <Section title="Code example" hint="copy-pasteable usage">
        <Stack gap={5}>
          <CodeBlock
            language="tsx"
            title="Horizontal (default)"
            code={`<ButtonGroup ariaLabel="Edit actions">
  <Button>Copy</Button>
  <Button>Cut</Button>
  <Button>Paste</Button>
</ButtonGroup>
`}
          />

          <CodeBlock
            language="tsx"
            title="Vertical sidebar toolbar"
            code={`<ButtonGroup ariaLabel="Pagination" vertical>
  <Button>Top</Button>
  <Button>Middle</Button>
  <Button>Bottom</Button>
</ButtonGroup>
`}
          />
        </Stack>
      </Section>
    </Stack>
  );
}
